import React, { useEffect, useState } from "react";
import { useDispatch,  } from "react-redux";
import { Modal } from "@mui/material";
import { updatePassword } from "../../actions";

const Perfil = ({isVisible,setIsVisible,setAnchorEl}) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('token')
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [input, setInput] = useState({
    contraseña: "",
    nuevaContraseña: "",
    confirmarContraseña: "",
  });
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [state, setstate] = useState(false);
  useEffect(() => {
    setIsButtonDisabled(!validateForm()); // <- Llamada a validateForm() aquí
    if(state){
      setIsVisible(false)
      setAnchorEl(null);
    }
  }, [dispatch, input,state]);
  
  const validateForm = () => {
    return (
      input.nuevaContraseña === input.confirmarContraseña &&
      validatePassword(input.nuevaContraseña) &&
      validateConfirmPassword(input.confirmarContraseña)
    );
  };
  const closeModal = ()=>{
    setstate(true)
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput((prevInput) => ({
      ...prevInput,
      [name]: value,
    }));
    if (name === "nuevaContraseña") {
      if (!validatePassword(value)) {
        setPasswordError(
          "La contraseña debe contener al menos 8 caracteres, una letra mayúscula, una letra minúscula y un número."
        );
      } else {
        setPasswordError("");
      }
    }
    if (name === "confirmarContraseña") {
      if (!validateConfirmPassword(value)) {
        setConfirmPasswordError(
          "La confirmación de la contraseña no coincide."
        );
      } else {
        setConfirmPasswordError("");
      }
    }
    setIsButtonDisabled(!validateForm());
  };
  const handleChangePassword = async () => {
    if (input.nuevaContraseña === input.confirmarContraseña) {
      dispatch(updatePassword(input,token))
      closeModal()
    } else {
      alert("Las contraseñas no coinciden");
    }
  };

  const validatePassword = (password) => {
    const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
    return regex.test(password);
  };
  const validateConfirmPassword = (confirmPassword) => {
    return input.nuevaContraseña === confirmPassword;
  };
  return (
        <Modal
          open={isVisible}
          onClose={closeModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="bg-white rounded-md shadow-md p-6 w-full md:w-80 mx-auto mt-10 md:mt-0">
           
           
            <div className="flex flex-row justify-between mb-5">
      
                <h2 id="modal-modal-title" className="w-44 h-8-2 text-lg font-medium">
                  Cambiar Contraseña
                </h2>              
              
                <button onClick={()=>closeModal()} className="p-2 w-10 rounded bg-red-700 text-white font-bold">X</button>
              
            </div>
           
            <div className="flex flex-col space-y-4">
              <input
                onChange={handleChange}
                type="password"
                name="contraseña"
                placeholder="Contraseña actual"
                className="border border-gray-400 rounded-md py-2 px-4"
              />
              <input
                onChange={handleChange}
                type="password"
                name="nuevaContraseña"
                placeholder="Nueva contraseña"
                className="border border-gray-400 rounded-md py-2 px-4"
              />
              {passwordError && (
                <p className="text-red-500 text-sm">{passwordError}</p>
              )}
              <input
                onChange={handleChange}
                type="password"
                name="confirmarContraseña"
                placeholder="Confirmar nueva contraseña"
                className="border border-gray-400 rounded-md py-2 px-4"
              />
              {confirmPasswordError && (
                <p className="text-red-500 text-sm">{confirmPasswordError}</p>
              )}
              <button
                onClick={handleChangePassword}
                className={` ${
                  isButtonDisabled
                    ? "cursor-not-allowed bg-gray-400 text-white py-2 px-4 rounded-md"
                    : "bg-green-700 text-white py-2 px-4 rounded-md"
                }`}
                disabled={isButtonDisabled}
              >
                Cambiar
              </button>
            </div>
          </div>
        </Modal>
  );
};

export default Perfil;
